function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useEffect, useRef, useState } from 'react';
import { useBtrNewsArticlesLazyQuery } from './btr-news.generated';
import { BTR_EDITORIAL_TAG } from './btr-more-config';
var useBTRNews = (initNewsArticles, primarySearchResult) => {
  var _useState = useState(initNewsArticles),
    _useState2 = _slicedToArray(_useState, 2),
    newsArticles = _useState2[0],
    setNewsArticles = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasMoreArticles = _useState4[0],
    setHasMoreArticles = _useState4[1];
  var initialized = useRef(false);
  var listingIdsDeps = JSON.stringify(primarySearchResult.listingIds);
  var _useBtrNewsArticlesLa = useBtrNewsArticlesLazyQuery({
      variables: {
        pagination: {
          pageSize: 4
        },
        topicSlug: BTR_EDITORIAL_TAG
      }
    }),
    _useBtrNewsArticlesLa2 = _slicedToArray(_useBtrNewsArticlesLa, 2),
    fetchArticles = _useBtrNewsArticlesLa2[0],
    articlesResult = _useBtrNewsArticlesLa2[1];
  useEffect(() => {
    if (initialized.current) {
      fetchArticles();
    }
    initialized.current = true;
  }, [fetchArticles, listingIdsDeps]);
  useEffect(() => {
    if (!articlesResult.loading && articlesResult.data) {
      var _articlesResult$data$;
      var allArticles = ((_articlesResult$data$ = articlesResult.data.newsTopicResults) === null || _articlesResult$data$ === void 0 ? void 0 : _articlesResult$data$.nodes) || [];
      setNewsArticles(allArticles.slice(0, 3));
      setHasMoreArticles(allArticles.length > 3);
    }
  }, [articlesResult]);
  return {
    newsArticles,
    hasMoreArticles
  };
};
export { useBTRNews };